import { initializeApp } from 'firebase/app'
import { getAnalytics, logEvent } from 'firebase/analytics'
import { getAuth, GoogleAuthProvider, OAuthProvider } from 'firebase/auth'
import { getStorage } from 'firebase/storage'
import { getRemoteConfig } from 'firebase/remote-config'
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check'

export const firebaseConfig = {
  apiKey: 'AIzaSyChDn6iMGrnRqaemIRKq6QobdboHHmGjEw',
  authDomain: 'voyp-278bf.firebaseapp.com',
  projectId: 'voyp-278bf',
  storageBucket: 'voyp-278bf.appspot.com',
  messagingSenderId: '403888540913',
  appId: '1:403888540913:web:087653ed4b9f2b7547ed50',
  measurementId: 'G-8ZQZ1RV86Y',
}

export const FCM_VAPID_KEY =
  'BF0v0y8mlEsN3M3suft3S9GPAXVHdMABR-e--d_HvXtAmGI14GXlDKEFgD8_bJbeFrZioR4MVOcJ1yePu2YnyTo'

export const app = initializeApp(firebaseConfig)

// Register a debug token in the Firebase console for localhost development.
if (import.meta.env.DEV) {
  ;(self as unknown as Record<string, unknown>).FIREBASE_APPCHECK_DEBUG_TOKEN = true
}

export const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaEnterpriseProvider('6LcQvOYpAAAAALUCrjFFrPvojeIdMrbR8cgcyuNc'),
  isTokenAutoRefreshEnabled: true,
})

export const analytics = getAnalytics(app)
export const auth = getAuth(app)
export const storage = getStorage(app)
export const remoteConfig = getRemoteConfig(app)

remoteConfig.settings.minimumFetchIntervalMillis = import.meta.env.DEV ? 0 : 60 * 60 * 1000

export const googleProvider = new GoogleAuthProvider()

export const appleProvider = new OAuthProvider('apple.com')
appleProvider.addScope('email')
appleProvider.addScope('name')

export type TrackParams = Record<string, string | number | boolean | undefined>

/**
 * Log a Firebase Analytics event. Names follow the Android/iOS apps so the
 * same action is one event across platforms. Like the mobile debug builds,
 * development only prints the event instead of sending it.
 */
export function track(event: string, params?: TrackParams) {
  if (import.meta.env.DEV) {
    if (import.meta.env.MODE !== 'test') console.debug('[analytics]', event, params ?? '')
    return
  }
  try {
    logEvent(analytics, event, params)
  } catch {
    // Analytics is best-effort; never let it break the app.
  }
}

/** Short error label for an event param (Firebase error code, else the message). */
export function errorParam(error: unknown): string {
  const code = (error as { code?: unknown })?.code
  const text = typeof code === 'string' ? code : error instanceof Error ? error.message : String(error)
  return text.slice(0, 100)
}
